import * as React from "react";
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import Stack from "@mui/material/Stack";
import { Typography } from "@mui/material";
import "./style.css";

const DescriptionAlert = (props) => {
  const { noticeDate , titleMessage , dateType } = props;
  return (
    <Stack sx={{ width: "558px" }} spacing={2} className="alert-desc">
      <Alert severity="info">
        <AlertTitle>
          {titleMessage}
        </AlertTitle>
        <Typography variant="body2" sx={{fontSize:"14px !important"}}>
          {dateType}:{" "}
          {new Date(noticeDate).toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "short",
            year: "numeric",
          })}
        </Typography>
      </Alert>
    </Stack>
  );
};

export default DescriptionAlert;
